import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--townsquare/goals-screen-space-flags';

import { type MessageTemplateContext } from '../../..';

import { SuccessMeasuresChangeboardingBanner } from './SuccessMeasuresModal';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

type RenderProps = MessageTemplateContext & PlacementRenderProps;

// This is the Message Frontend. In this Placement we have render.Component which takes a React Component which will render your message in the Placement.
export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<RenderProps>(),
		Component: ({ isAdmin, settingsPageRedirect, onMoreButtonClicked, dismiss }: RenderProps) => {
			return (
				<SuccessMeasuresChangeboardingBanner
					isAdmin={isAdmin}
					settingsPageRedirect={settingsPageRedirect}
					onMoreButtonClicked={onMoreButtonClicked}
					dismiss={dismiss}
				/>
			);
		},
	},
});
